import { registerLocaleData } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import localePL from '@angular/common/locales/pl';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MenuService } from '@psei/ng';
import { DialogModule } from '@psei/ng/dialog';
import { DimmerModule } from '@psei/ng/dimmer';
import { DrawerModule } from '@psei/ng/drawer';
import { IconModule } from '@psei/ng/icon';
import { TopBarModule } from '@psei/ng/top-bar';
import { PpbSharedModule } from 'projects/ppb-shared-library/src/lib/ppb-shared.module';
import {
  PseiNgCustomModule,
} from 'projects/ppb-shared-library/src/lib/psei-ng-custom.module';
import { SharedApiService } from 'projects/ppb-shared-library/src/lib/services/interfaces/shared-api.service';
import {
  phonePrefixesProviderFactory,
  PhonePrefixesService, REQUEST_URI
} from 'projects/ppb-shared-library/src/lib/services/phone-prefixes.service';
import { PpbLibAppModule } from '../../projects/ppb-shared-library/src/lib/app/ppb-lib-app.module';
import { PAGE_TITLE } from '../../projects/ppb-shared-library/src/lib/services/confirmation-document.service';
import {
  dictionary2ProviderFactory,
  MultiLangDictService, USE_MULTI_LANG_DICT
} from '../../projects/ppb-shared-library/src/lib/services/multi-lang-dict.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PpbAccountActivationModule } from './ppb/ppb-account-activation/ppb-account-activation.module';
import { PpbAccountRegistrationModule } from './ppb/ppb-account-registration/ppb-account-registration.module';
import { PpbAccountIdentityComponent } from './ppb/ppb-account/ppb-account-identity/ppb-account-identity.component';
import { PpbDashboardModule } from './ppb/ppb-dashboard/ppb-dashboard.module';
import { PpbInvitationModule } from './ppb/ppb-invitation/ppb-invitation.module';
import { PpbLoginModule } from './ppb/ppb-login/ppb-login.module';
import { PpbPasswordResetModule } from './ppb/ppb-password-reset/ppb-password-reset.module';
import { PpbPasswordSetModule } from './ppb/ppb-password-set/ppb-password-set.module';
import { PpbRegistrationCodesModule } from './ppb/ppb-registration-codes/ppb-registration-codes.module';
import { PpbModule } from './ppb/ppb.module';
import { PpbShareModule } from './ppb/shared/ppb-share.module';
import { languageProviderFactory, LanguageService } from './ppb/shared/services/language.service';
import { PpbApiService } from './ppb/shared/services/ppb-api.service';
// tslint:disable-next-line: ordered-imports
import { ApiModule } from './shared/services/api.module';
import { HttpLanguageInterceptorService } from './shared/services/interceptors/language/http-language-interceptor.service';
// tslint:disable-next-line:max-line-length
import {
  HttpRefreshTokenInterceptorService
} from './shared/services/interceptors/refresh-token/http-refresh-token-interceptor.service';
import {
  PpbToasterInterceptor
} from './shared/services/interceptors/toaster/pbb-toaster-interceptor';
import { authProviderFactory, LoadAppService } from './shared/services/load-app.service';
import { PpbMenuServiceService } from './shared/services/ppb-menu-service.service';
import { BrowserNotSupportedComponent } from './technical/browser-not-supported/browser-not-supported.component';
import { E404Component } from './technical/e404/e404.component';
import { configProviderFactory, ConfigurationService } from './technical/version/configuration.service';

registerLocaleData(localePL);

@NgModule({
  declarations: [
    AppComponent,
    E404Component,
    BrowserNotSupportedComponent,
    PpbAccountIdentityComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    PseiNgCustomModule,
    ReactiveFormsModule,
    PpbModule,
    FlexLayoutModule,
    ApiModule,
    PpbLoginModule,
    PpbLibAppModule,
    PpbInvitationModule,
    PpbAccountActivationModule,
    PpbPasswordResetModule,
    PpbPasswordSetModule,
    PpbRegistrationCodesModule,
    PpbDashboardModule,
    PpbSharedModule,
    PpbShareModule,
    PpbAccountRegistrationModule,
    DialogModule.forRoot('window'),
    DimmerModule.forRoot(),
    DrawerModule.forRoot(),
    IconModule.forRoot(),
    TopBarModule,
  ],
  bootstrap: [AppComponent],
  providers: [
    { provide: SharedApiService, useExisting: PpbApiService },
    { provide: MenuService, useClass: PpbMenuServiceService },
    {
      provide: REQUEST_URI,
      useValue: '/api/v1/dictionary/phone-prefixes'
    },
    {
      provide: USE_MULTI_LANG_DICT,
      useValue: true
    },
    { provide: MultiLangDictService },
    {
      provide: PAGE_TITLE,
      useValue: '/api/v1/accounts/confirmation-documents'
    },
    {
      provide: APP_INITIALIZER,
      useFactory: languageProviderFactory,
      deps: [LanguageService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: dictionary2ProviderFactory,
      deps: [MultiLangDictService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: phonePrefixesProviderFactory,
      deps: [PhonePrefixesService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: configProviderFactory,
      deps: [ConfigurationService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: authProviderFactory,
      deps: [LoadAppService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PpbToasterInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRefreshTokenInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpLanguageInterceptorService,
      multi: true
    }
  ]
})
export class AppModule {
}
